import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/svg/CitrusLink-2020.svg';

export const LogoButton = () => (
  <Link className="min-w-[160px] w-[160px] p-4" to="/">
    <Logo />
  </Link>
);
